import squareJsIcon from 'assets/themejs.svg';
import themenodecon from 'assets/themenode.svg';
import themereact from 'assets/themereact.svg';
import NeonStack from './NeonStack';

const MyStack = () => {
  return (
    <>
      <section className='mystack-main-container' id='#expertise'>
        <div className='stack-table' data-aos='fade-up'>
          <div className='stack-table__row1'>
            <div
              className='stack-main-header anime-grad hover-underline-animation'
              data-aos='fade-left'
            >
              <h2>Full STACK Developer</h2>
            </div>
            <div className='stack-table__neonstack'>
              <NeonStack />
            </div>
          </div>
          <div className='stack-table-main' data-aos='fade-left'>
            <div className='stack-column-one '>
              <div className='display-flex'>
                <div className='stack-header-icon'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke-width='1.5'
                    stroke='currentColor'
                    class='w-6 h-6'
                    height='40px'
                    data-aos='flip-up'
                  >
                    <path
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      d='M6.75 7.5l3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0021 18V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v12a2.25 2.25 0 002.25 2.25z'
                    />
                  </svg>
                </div>

                <h2
                  className='stack-header_two chonky-underline-violet has-hover-anim snipcss-4jxlJ style-HyoFo'
                  data-aos='fade-up'
                >
                  Software Development
                </h2>
              </div>
              <div className='display-flex' data-aos='flip-up'>
                <div className='display-flex'>
                  <div className='stack-shake-animation'>
                    <img
                      src={squareJsIcon}
                      alt='Square.js Icon'
                      style={{
                        width: '45px',
                        height: '60px',
                      }}
                    />
                  </div>

                  <div className='hover-underline-animation'>
                    Veteran in JavaScript
                  </div>
                </div>
              </div>
              <div className='stack-rows'>
                <div className='stack-paragraph-copy'>
                  <div className='stack-paragraph-copy-h1'>&lt;p&gt;</div>
                  <div className='stack-paragraph-copy-paragraph'>
                    <p data-aos='fade-up' className='hover-underline-animation'>
                      Master in both functional and OOP: JavaScript, Python,
                      Java, TypeScript.
                    </p>
                  </div>

                  <div className='stack-paragraph-copy-h1'>&lt;/p&gt;</div>
                  <div className='margin-extra'>
                    <div className='stack-paragraph-copy-paragraph_2'>
                      <div>
                        <p>
                          <p
                            className='anime-grad'
                            style={{ color: '#5c5c5c', textAlign: 'right' }}
                          >
                            Additional Skills:-
                          </p>
                        </p>
                      </div>
                      <div>
                        {' '}
                        <p data-aos='fade-left'>
                          <img
                            src='assets/icons8-typescript.svg'
                            alt='TypeScripticon'
                          />

                          <img src='assets/c-solid.svg' alt='C-icon' />

                          <img src='assets/python.svg' alt='Pythonicon' />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='stack-column-two'>
              <div className='display-flex'>
                <div className='stack-header-icon'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke-width='1.5'
                    stroke='currentColor'
                    class='w-6 h-6'
                    height='40px'
                  >
                    <path
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      d='M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25'
                    />
                  </svg>
                </div>

                <h2
                  className='stack-header_two chonky-underline-violet has-hover-anim snipcss-4jxlJ style-HyoFo'
                  data-aos='fade-up'
                >
                  Frontend Dev
                </h2>
              </div>
              <div className='display-flex' data-aos='flip-up'>
                <div className='display-flex'>
                  <div className='stack-shake-animation'>
                    <img
                      src={themereact}
                      alt='themereact Icon'
                      style={{
                        width: '45px',
                        height: '60px',
                        borderRadius: '15px',
                      }}
                    />
                  </div>

                  <div className='hover-underline-animation'>
                    Skilled in React.js
                  </div>
                </div>
              </div>
              <div className='stack-rows'>
                <div className='stack-rows'>
                  <div className='stack-paragraph-copy'>
                    <div className='stack-paragraph-copy-h1'>&lt;p&gt;</div>
                    <div className='stack-paragraph-copy-paragraph'>
                      <p
                        data-aos='fade-up'
                        className='hover-underline-animation'
                      >
                        Built 20+ projects using React.js along with Redux
                        Toolkit.
                      </p>
                    </div>

                    <div className='stack-paragraph-copy-h1'>&lt;/p&gt;</div>
                    <div className='margin-extra'>
                      <div className='stack-paragraph-copy-paragraph_2'>
                        <div>
                          <p
                            style={{ color: '#5c5c5c', textAlign: 'right' }}
                            className='anime-grad'
                          >
                            Additional Skills:-
                          </p>
                        </div>
                        <div data-aos='fade-left'>
                          {' '}
                          <p>
                            <img
                              src='assets/icons8-redux.svg'
                              alt='reduxicon'
                            />

                            <img src='assets/c-solid.svg' alt='C-icon' />

                            <img
                              src='assets/nextjs-icon-svgrepo-com.svg'
                              alt='nextjsicon'
                            />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='stack-column-three'>
              <div className='display-flex'>
                <div className='stack-header-icon'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke-width='1.5'
                    stroke='currentColor'
                    class='w-6 h-6'
                    height='40px'
                  >
                    <path
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      d='M5.25 14.25h13.5m-13.5 0a3 3 0 01-3-3m3 3a3 3 0 100 6h13.5a3 3 0 100-6m-16.5-3a3 3 0 013-3h13.5a3 3 0 013 3m-19.5 0a4.5 4.5 0 01.9-2.7L5.737 5.1a3.375 3.375 0 012.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 01.9 2.7m0 0a3 3 0 01-3 3m0 3h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008zm-3 6h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008z'
                    />
                  </svg>
                </div>

                <h2
                  className='stack-header_two chonky-underline-violet has-hover-anim snipcss-4jxlJ style-HyoFo'
                  data-aos='fade-up'
                >
                  Backend Dev
                </h2>
              </div>
              <div className='display-flex' data-aos='flip-up'>
                <div className='display-flex'>
                  {/* <div> */}
                  <div className='stack-shake-animation'>
                    <img
                      src={themenodecon}
                      alt='Square.js Icon'
                      style={{
                        width: '45px',
                        height: '60px',
                        borderRadius: '10px',
                      }}
                    />
                  </div>
                  {/* </div> */}
                  <div className='hover-underline-animation'>
                    Master in node.js
                  </div>
                </div>
              </div>
              <div className='stack-rows'>
                <div className='stack-rows'>
                  <div className='stack-paragraph-copy'>
                    <div className='stack-paragraph-copy-h1'>&lt;p&gt;</div>
                    <div className='stack-paragraph-copy-paragraph'>
                      <p
                        data-aos='fade-up'
                        className='hover-underline-animation'
                      >
                        A backend dev at heart, deployed apps using an array of
                        advanced strategies.
                      </p>
                    </div>

                    <div className='stack-paragraph-copy-h1'>&lt;/p&gt;</div>
                    <div className='margin-extra'>
                      <div className='stack-paragraph-copy-paragraph_2'>
                        <div>
                          <p
                            className='anime-grad'
                            style={{ color: '#5c5c5c', textAlign: 'right' }}
                          >
                            Additional Skills:-
                          </p>
                        </div>
                        <div data-aos='fade-left'>
                          {' '}
                          <p>
                            <img
                              src='assets/icons8-express-js.svg'
                              alt='TypeScripticon'
                            />

                            <img src='assets/c-solid.svg' alt='C-icon' />

                            <img src='assets/python.svg' alt='Pythonicon' />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='mystackdb_container' data-aos='fade-up'>
          <div class='mystackdb_card'>
            <div class='mystackdb_face mystackdb_face1'>
              <div class='mystackdb_content'>
                <img
                  src='assets/icons8-mongodb-a-cross-platform-document-oriented-database-program-96.png'
                  alt='DatabaseIntegrationicon'
                />
                <h3>MongoDB</h3>
              </div>
            </div>
            <div class='mystackdb_face mystackdb_face2'>
              <div class='mystackdb_content'>
                <p>
                  Can create a MongoDB Schema and Model even while sleeping!{' '}
                  <br />
                  Solid Understanding of Aggregate Pipeline, Filtering, Sort,
                  Middlewares. I use mongoose.
                </p>

                <img
                  src='assets/icons8-mongoose.svg'
                  alt='DatabaseIntegrationicon'
                />
              </div>
            </div>
          </div>
          <div class='mystackdb_card' data-aos='fade-up'>
            <div class='mystackdb_face mystackdb_face1 colorblue'>
              <div class='mystackdb_content'>
                <img
                  src='assets/icons8-mysql.svg'
                  alt='DatabaseIntegrationicon'
                />
                <h3>MYSQL</h3>
              </div>
            </div>
            <div class='mystackdb_face mystackdb_face2'>
              <div class='mystackdb_content'>
                <p>
                  With a passion for querying databases and optimizing data
                  flow, I'm on a mission to make every piece of information
                  dance in harmony.
                </p>
              </div>
            </div>
          </div>
          <div class='mystackdb_card' data-aos='fade-up'>
            <div class='mystackdb_face mystackdb_face1 colororange'>
              <div class='mystackdb_content'>
                <img
                  src='assets/git-seeklogo.com.svg'
                  alt='versioncontrolicon'
                />
                <h3>Git </h3>
              </div>
            </div>
            <div class='mystackdb_face mystackdb_face2'>
              <div class='mystackdb_content'>
                <p>A version control virtuoso, I 'git' it everyday!!</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MyStack;
